import mobileImage from "../../../assets/images/phone-android-ut.png";
const HeroImage: React.FC = () => {
  return <img src={mobileImage} className="w-[300px] lg:w-[450px]" alt="mobile" />;
};

export default HeroImage;
